import { render, staticRenderFns } from "./PromoCropper.vue?vue&type=template&id=f44be5c4"
import script from "./PromoCropper.vue?vue&type=script&lang=js"
export * from "./PromoCropper.vue?vue&type=script&lang=js"
import style0 from "./PromoCropper.vue?vue&type=style&index=0&id=f44be5c4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports